import { render } from "./menu2.vue?vue&type=template&id=58389055"
import script from "./menu2.vue?vue&type=script&lang=ts"
export * from "./menu2.vue?vue&type=script&lang=ts"
script.render = render

export default script